import { Injectable, isDevMode } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MaintenanceDaoService } from '../../dao/maintenance-dao-service/maintenance-dao.service';
import { Device } from '../../models/device-models/device.model';
import { APP_CONFIG } from 'src/app/config';
import { UserStorageService } from '../user-storage-service/user-storage.service';
import { SecurityService } from '../security-service/security.service';
import { sha256 } from 'js-sha256';
declare const window;

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  appVersion: string;
  layoutListener = new Subject();
  blackScreenListener = new Subject();

  constructor(private maintenanceDaoService: MaintenanceDaoService,
              private securityService: SecurityService,
              private userStorageService: UserStorageService) {
                this.appVersion = APP_CONFIG.appVersion;

  }

  public isRegistered() {
    return Observable.create(
      (o) => {
        this.updateDevice(
          this.userStorageService.getContext(),
          this.userStorageService.getLang(),
          this.userStorageService.getOAuthToken(),
          this.userStorageService.getUDID(),
          this.userStorageService.getDeviceData()
        ).subscribe(
          (res) => {
            if (res.context) {
              o.next({isRegistered: true, context: res.context});
            } else if (res.token) {
              this.userStorageService.deleteOldData();
              o.next({isRegistered: false, token: res.token});
            }
          },
          (error) => {
            console.dir(error);
          }
        );
      }
    );
  }

  // LAYOUT
  public listenRefreshLayout() {
    return this.layoutListener.asObservable();
  }
  public refreshLayout() {
    this.layoutListener.next();
  }

  // BLACK_SCREEN
  public listenBlackScreen() {
    return this.blackScreenListener.asObservable();
  }

  public lockScreen() {
    const device = this.userStorageService.getDeviceData();
    device.Brightness = 100;
    device.Locked = true;
    this.updateDevice(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      'oauthToken',
      this.userStorageService.getUDID(),
      device
    ).subscribe();
    this.blackScreenListener.next({brightness: 0});
  }
  public unlockScreen() {
    const device = this.userStorageService.getDeviceData();
    device.Brightness = 0;
    device.Locked = false;
    this.updateDevice(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      'oauthToken',
      this.userStorageService.getUDID(),
      device
    ).subscribe();
    this.blackScreenListener.next({brightness: 100});

  }
  public setBrightness(brightness) {
    const device = this.userStorageService.getDeviceData();
    device.Brightness = brightness;
    this.updateDevice(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      'oauthToken',
      this.userStorageService.getUDID(),
      device
    ).subscribe();
    this.blackScreenListener.next({brightness});
  }

  public refreshDeviceInfo() {
    this.securityService.getFingerPrint().subscribe(
      (res) => {
        this.updateDevice(
          this.userStorageService.getContext(),
          this.userStorageService.getLang(),
          'oauthToken',
          this.userStorageService.getUDID(),
          this.fingerPrintDevice(res.components)
        ).subscribe();
      }
    );
  }

  public updateDevice(context, lang, oauthToken, udid, device) {
    const application = device.Application.toString();
    const appVersion = device.AppVersion.toString();
    const battery = device.Battery.toString();
    const brand = device.Brand.toString();
    const brightness = device.Brightness;
    const connectionDevice = device.ConnectionDevice.toString();
    const description = device.Description.toString();
    const deviceName = device.DeviceName.toString();
    const deviceType = device.DeviceType.toString();
    const ipAddress = device.IpAddress.toString();
    const locked = device.Locked;
    const mac = device.Mac.toString();
    const major = device.Major;
    const minor = device.Minor;
    const model = device.Model.toString();
    const note = device.Note.toString();
    const notifyBackOffice = device.NotifyBackOffice;
    const osVersion = device.OsVersion.toString();
    const paperOut = device.PaperOut;
    const platform = device.Platform.toString();
    const serialNumber = device.SerialNumber.toString();
    const signal = device.Signal;
    const volume = device.Volume;
    const wifiSsid = device.WifiSsid.toString();
    return Observable.create(
      (o) => {
        this.maintenanceDaoService.updateDevice(
          context, lang, oauthToken, udid, application, appVersion, battery, brand,
          brightness, connectionDevice, description, deviceName, deviceType, ipAddress,
          locked, mac, major, minor, model, note, notifyBackOffice, osVersion, paperOut,
          platform, null, serialNumber, signal, volume, wifiSsid
        ).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res['data']);
          },
          (error) => { o.error(error); }
        );
      }
    );
  }

  public isOffline() {
    return Observable.create(
      (o) => {
        window.addEventListener('offline', (offline) => {
          if (offline) {
            o.next(true);
          }
        });
        window.addEventListener('online', (online) => {
          if (online) {
            o.next(false);
          }
        });
      }
    );
  }

  public fingerPrintDevice(components) {
    const device = new Device();
    device.Application = 'MT_CONTROL';
    device.DeviceType = 'CONTROL';
    device.Mac = 'FF:FF:FF:FF';
    device.DeviceName = 'mTurnControl';
    device.Description = '';
    device.Note = 'Note';
    device.Battery = '100';
    device.Brand = 'Brand';
    device.Model = '';
    device.SerialNumber = sha256(' / ' + window.navigator.userAgent).replace(/\D/g, '').slice(0, 15);
    device.Platform = 'PC';
    device.OsVersion = 'WEB';
    device.AppVersion = this.appVersion;
    device.ConnectionDevice = '-';
    device.WifiSsid = '-';
    device.IpAddress = '0.0.0.0';
    device.Signal = 0;
    device.Major = 0;
    device.Minor = 0;
    device.PaperOut = false;
    device.Brightness = 0;
    device.Volume = 0;
    device.NotifyBackOffice = true;
    device.Locked = false;
    return device;
  }
}
